/** Mirror of backend/weddings/event_types.py — the stored value drives everything. */
export const EVENT_TYPES = [
  { value: "wedding", label: "Mariage", example: "Mariage de Camille et Antoine", detail: { key: "celebrants_names", label: "Noms des mariés" } },
  { value: "baptism", label: "Baptême", example: "Baptême de Louise", detail: { key: "child_first_name", label: "Prénom de l'enfant" } },
  { value: "birthday", label: "Anniversaire", example: "Anniversaire de Sophie", detail: { key: "honoree_name", label: "Personne fêtée" } },
  { value: "funeral_reception", label: "Réception après obsèques", example: "Réception de la famille Martin", detail: null },
  { value: "communion", label: "Communion", example: "Communion de Gabriel", detail: { key: "child_first_name", label: "Prénom de l'enfant" } },
  { value: "family_meal", label: "Repas de famille", example: "Repas de la famille Dupont", detail: { key: "organization_name", label: "Nom de la famille" } },
  { value: "corporate", label: "Événement professionnel", example: "Déjeuner de l'équipe Acme", detail: { key: "organization_name", label: "Société / organisation" } },
  { value: "other", label: "Autre événement", example: "Titre libre", detail: null },
];

export const typeOf = (value) => EVENT_TYPES.find((t) => t.value === value) || null;
export const typeLabel = (value, other = "") =>
  value === "other" && other ? other : (typeOf(value)?.label || "Réception");
export const isSober = (value) => value === "funeral_reception";

export const SERVICE_LABELS = { starter: "Entrée", main: "Plat", dessert: "Dessert" };
